import React from "react";

export default function menuIcon(title: string) {
  switch (title) {
    case "DATA THẺ":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 9H18.75M15 12H18.75M15 15H18.75M4.5 19.5H19.5C20.7426 19.5 21.75 18.4926 21.75 17.25V6.75C21.75 5.50736 20.7426 4.5 19.5 4.5H4.5C3.25736 4.5 2.25 5.50736 2.25 6.75V17.25C2.25 18.4926 3.25736 19.5 4.5 19.5ZM10.5 9.375C10.5 10.4105 9.66053 11.25 8.625 11.25C7.58947 11.25 6.75 10.4105 6.75 9.375C6.75 8.33947 7.58947 7.5 8.625 7.5C9.66053 7.5 10.5 8.33947 10.5 9.375ZM11.7939 15.7114C10.8489 16.2147 9.77021 16.5 8.62484 16.5C7.47948 16.5 6.40074 16.2147 5.45581 15.7114C5.92986 14.4207 7.16983 13.5 8.62484 13.5C10.0799 13.5 11.3198 14.4207 11.7939 15.7114Z"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "ĐƠN HÀNG":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 12H12.75M9 15H12.75M9 18H12.75M15.75 18.75H18C19.2426 18.75 20.25 17.7426 20.25 16.5V6.10822C20.25 4.97324 19.405 4.01015 18.2739 3.91627C17.9006 3.88529 17.5261 3.85858 17.1505 3.83619M11.3495 3.83619C11.2848 4.04602 11.25 4.26894 11.25 4.5C11.25 4.91421 11.5858 5.25 12 5.25H16.5C16.9142 5.25 17.25 4.91421 17.25 4.5C17.25 4.26894 17.2152 4.04602 17.1505 3.83619M11.3495 3.83619C11.6328 2.91757 12.4884 2.25 13.5 2.25H15C16.0116 2.25 16.8672 2.91757 17.1505 3.83619M11.3495 3.83619C10.9739 3.85858 10.5994 3.88529 10.2261 3.91627C9.09499 4.01015 8.25 4.97324 8.25 6.10822V8.25M8.25 8.25H4.875C4.25368 8.25 3.75 8.75368 3.75 9.375V20.625C3.75 21.2463 4.25368 21.75 4.875 21.75H14.625C15.2463 21.75 15.75 21.2463 15.75 20.625V9.375C15.75 8.75368 15.2463 8.25 14.625 8.25H8.25ZM6.75 12H6.7575V12.0075H6.75V12ZM6.75 15H6.7575V15.0075H6.75V15ZM6.75 18H6.7575V18.0075H6.75V18Z"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "THU CHI":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.5 16.19H9.5C9.09 16.19 8.75 15.85 8.75 15.44C8.75 15.03 9.09 14.69 9.5 14.69H14.5C14.91 14.69 15.25 15.03 15.25 15.44C15.25 15.85 14.91 16.19 14.5 16.19Z"
            fill="#5E677C"
          />
          <path
            d="M12 18.75C11.59 18.75 11.25 18.41 11.25 18V13C11.25 12.59 11.59 12.25 12 12.25C12.41 12.25 12.75 12.59 12.75 13V18C12.75 18.41 12.41 18.75 12 18.75Z"
            fill="#5E677C"
          />
          <path
            d="M5.1997 10.46C5.0097 10.46 4.8197 10.38 4.6697 10.24C4.4597 10.03 4.3897 9.7 4.5097 9.42L6.3697 4.98C6.4097 4.89 6.4297 4.83 6.4597 4.78C7.9397 1.37 9.8297 0.539999 13.1697 1.82C13.3597 1.89 13.5097 2.04 13.5897 2.23C13.6697 2.42 13.6697 2.63 13.5897 2.82L10.6597 9.62C10.5397 9.89 10.2697 10.07 9.9697 10.07H7.1197C6.5497 10.07 6.0097 10.18 5.4897 10.4C5.3997 10.44 5.2997 10.46 5.1997 10.46ZM10.6097 2.75C9.3697 2.75 8.6097 3.56 7.8197 5.4C7.8097 5.43 7.7897 5.46 7.7797 5.49L6.4697 8.6C6.6897 8.58 6.8997 8.57 7.1197 8.57H9.4697L11.8797 2.97C11.4097 2.82 10.9897 2.75 10.6097 2.75Z"
            fill="#5E677C"
          />
          <path
            d="M18.2902 10.27C18.2202 10.27 18.1402 10.26 18.0702 10.24C17.7002 10.13 17.2902 10.07 16.8702 10.07H9.97023C9.72023 10.07 9.48023 9.93999 9.34023 9.72999C9.21023 9.51999 9.18023 9.24999 9.28023 9.01999L12.1802 2.28999C12.3302 1.92999 12.7702 1.68999 13.1402 1.80999C13.2602 1.84999 13.3702 1.89999 13.4902 1.94999L15.8502 2.93999C17.2302 3.50999 18.1502 4.10999 18.7502 4.82999C18.8702 4.96999 18.9702 5.11999 19.0602 5.26999C19.1702 5.43999 19.2702 5.64999 19.3402 5.85999C19.3702 5.92999 19.4202 6.05999 19.4502 6.19999C19.7302 7.13999 19.5902 8.30999 18.9902 9.80999C18.8702 10.09 18.5902 10.27 18.2902 10.27ZM11.1102 8.56999H16.8802C17.2002 8.56999 17.5102 8.59999 17.8202 8.64999C18.1002 7.77999 18.1602 7.10999 18.0002 6.56999C17.9802 6.47999 17.9602 6.43999 17.9502 6.39999C17.8902 6.23999 17.8502 6.14999 17.8002 6.06999C17.7302 5.95999 17.6802 5.86999 17.6002 5.77999C17.1702 5.25999 16.4102 4.77999 15.2802 4.31999L13.3002 3.48999L11.1102 8.56999Z"
            fill="#5E677C"
          />
          <path
            d="M15.9 22.75H8.1C7.82 22.75 7.56 22.73 7.3 22.7C3.79 22.46 1.79 20.46 1.55 16.91C1.52 16.69 1.5 16.42 1.5 16.15V14.2C1.5 11.95 2.84 9.92001 4.91 9.02001C5.61 8.72001 6.36 8.57001 7.13 8.57001H16.89C17.46 8.57001 18.01 8.65001 18.52 8.81001C20.87 9.52001 22.52 11.74 22.52 14.2V16.15C22.52 16.37 22.51 16.58 22.5 16.78C22.28 20.69 20 22.75 15.9 22.75ZM7.12 10.07C6.55 10.07 6.01 10.18 5.49 10.4C3.97 11.06 2.99 12.55 2.99 14.2V16.15C2.99 16.36 3.01 16.57 3.03 16.77C3.22 19.62 4.62 21.02 7.43 21.21C7.68 21.24 7.88 21.26 8.09 21.26H15.89C19.19 21.26 20.81 19.81 20.97 16.71C20.98 16.53 20.99 16.35 20.99 16.15V14.2C20.99 12.39 19.78 10.77 18.06 10.24C17.69 10.13 17.28 10.07 16.86 10.07H7.12Z"
            fill="#5E677C"
          />
          <path
            d="M2.24023 14.95C1.83023 14.95 1.49023 14.61 1.49023 14.2V11.27C1.49023 8.12001 3.72023 5.40001 6.80023 4.80001C7.07023 4.75001 7.35023 4.85001 7.53023 5.06001C7.70023 5.27001 7.75023 5.57001 7.64023 5.82001L5.89023 10C5.81023 10.18 5.67023 10.32 5.50023 10.4C3.98023 11.06 3.00023 12.55 3.00023 14.2C2.99023 14.61 2.66023 14.95 2.24023 14.95ZM5.60023 6.82001C4.32023 7.54001 3.39023 8.80001 3.10023 10.27C3.54023 9.82001 4.05023 9.44001 4.63023 9.16001L5.60023 6.82001Z"
            fill="#5E677C"
          />
          <path
            d="M21.7601 14.95C21.3501 14.95 21.0101 14.61 21.0101 14.2C21.0101 12.39 19.8001 10.77 18.0801 10.24C17.8801 10.18 17.7101 10.04 17.6201 9.84999C17.5301 9.65999 17.5201 9.43999 17.6001 9.24999C18.0701 8.07999 18.1901 7.22999 18.0001 6.56999C17.9801 6.47999 17.9601 6.43999 17.9501 6.39999C17.8201 6.10999 17.8901 5.76999 18.1201 5.54999C18.3501 5.32999 18.7001 5.27999 18.9801 5.42999C21.1601 6.56999 22.5101 8.80999 22.5101 11.27V14.2C22.5101 14.61 22.1701 14.95 21.7601 14.95ZM19.2501 9.08999C19.8801 9.37999 20.4401 9.78999 20.9101 10.28C20.7201 9.29999 20.2501 8.40999 19.5601 7.70999C19.5101 8.12999 19.4101 8.58999 19.2501 9.08999Z"
            fill="#5E677C"
          />
        </svg>
      );

    case "ĐỐI TÁC QUẸT":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_527_13771)">
            <path
              d="M23.7141 7.99326L18.5203 2.79951C18.2719 2.55107 17.8687 2.54169 17.6063 2.77607L15.5484 4.65107L11.1141 2.63076C9.78281 2.02607 8.18438 2.60263 7.55156 3.91982L5.23594 8.72451H2.11875C1.00313 8.72451 0.09375 9.63388 0.09375 10.7495V19.5386C0.09375 20.6542 1.00313 21.5636 2.11875 21.5636H14.3344C15.45 21.5636 16.3594 20.6542 16.3594 19.5386V16.3886L23.7188 8.92138C23.9719 8.66357 23.9719 8.24638 23.7141 7.99326ZM15.0328 19.5386C15.0328 19.9276 14.7188 20.2417 14.3297 20.2417H2.11875C1.72969 20.2417 1.41563 19.9276 1.41563 19.5386V10.7495C1.41563 10.3604 1.72969 10.0464 2.11875 10.0464H4.81406C4.78125 10.862 5.18437 11.6589 5.92969 12.1042C7.0875 12.8026 8.60156 12.3011 9.15 11.2183L9.77813 10.0464H14.3297C14.7188 10.0464 15.0328 10.3604 15.0328 10.7495V19.5386ZM10.4906 8.72451L10.8 8.15263C10.875 8.01201 10.9969 7.97451 11.0672 7.96513C11.1328 7.95576 11.2641 7.95576 11.3766 8.06826L12.0375 8.72451H10.4906ZM14.3344 8.72451H13.9078L12.3094 7.13076C11.9297 6.75107 11.4047 6.57763 10.8703 6.65732C10.3359 6.73701 9.88594 7.05107 9.63281 7.52919L7.9875 10.5948C7.67812 11.0776 7.13906 11.2651 6.61406 10.9745C6.17813 10.712 6.01406 10.1636 6.23438 9.70419L8.74688 4.49638C9.07031 3.82138 9.89062 3.52607 10.5703 3.83544L15.2906 5.98701L20.0531 10.7495L16.3547 14.5042V10.7495C16.3547 9.63388 15.45 8.72451 14.3344 8.72451ZM20.9859 9.81201L16.6312 5.46201L18.0328 4.18701L22.3125 8.46201L20.9859 9.81201Z"
              fill="#5E677C"
            />
            <path
              d="M3.83906 18.076H3.16875C2.80312 18.076 2.50781 18.3714 2.50781 18.737C2.50781 19.1026 2.80312 19.3979 3.16875 19.3979H3.83906C4.20469 19.3979 4.5 19.1026 4.5 18.737C4.5 18.3714 4.20469 18.076 3.83906 18.076Z"
              fill="#5E677C"
            />
            <path
              d="M6.98945 18.076H6.31914C5.95352 18.076 5.6582 18.3714 5.6582 18.737C5.6582 19.1026 5.95352 19.3979 6.31914 19.3979H6.98945C7.35508 19.3979 7.65039 19.1026 7.65039 18.737C7.65039 18.3714 7.35508 18.076 6.98945 18.076Z"
              fill="#5E677C"
            />
            <path
              d="M10.134 18.076H9.46367C9.09805 18.076 8.80273 18.3714 8.80273 18.737C8.80273 19.1026 9.09805 19.3979 9.46367 19.3979H10.134C10.4996 19.3979 10.7949 19.1026 10.7949 18.737C10.7949 18.3714 10.4996 18.076 10.134 18.076Z"
              fill="#5E677C"
            />
            <path
              d="M13.2844 18.076H12.6141C12.2484 18.076 11.9531 18.3714 11.9531 18.737C11.9531 19.1026 12.2484 19.3979 12.6141 19.3979H13.2844C13.65 19.3979 13.9453 19.1026 13.9453 18.737C13.9453 18.3714 13.65 18.076 13.2844 18.076Z"
              fill="#5E677C"
            />
            <path
              d="M3.16875 16.7261H5.71406C6.07969 16.7261 6.375 16.4308 6.375 16.0651V13.5198C6.375 13.1542 6.07969 12.8589 5.71406 12.8589H3.16875C2.80312 12.8589 2.50781 13.1542 2.50781 13.5198V16.0651C2.50781 16.4308 2.80312 16.7261 3.16875 16.7261ZM3.82969 14.1808H5.04844V15.3995H3.82969V14.1808Z"
              fill="#5E677C"
            />
          </g>
          <defs>
            <clipPath id="clip0_527_13771">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case "QUẢN LÝ":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.1522 20.3129H6C3.79086 20.3129 2 18.522 2 16.3129V6C2 3.79086 3.79086 2 6 2H16.3044C18.5136 2 20.3044 3.79086 20.3044 6V11.1565"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M5.66016 14.7275L8.21005 10.6457C8.53134 10.1314 9.23276 10.0192 9.69852 10.4075L11.7788 12.1418C12.2256 12.5144 12.895 12.4283 13.233 11.9548L15.7642 8.40952"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M19.2383 18.7487L19.2379 18.7468L19.3558 18.7187M19.2383 18.7487C19.2388 18.7508 19.2393 18.7529 19.2399 18.755L19.3574 18.7256M19.2383 18.7487L19.2796 18.9221L19.2814 18.9296L19.2827 18.9351L19.2383 18.7487ZM19.3558 18.7187L19.3574 18.7256M19.3558 18.7187L19.9675 18.5732M19.3558 18.7187L19.3531 18.7075M19.3574 18.7256L19.9675 18.5732M19.3574 18.7256L19.3975 18.894L19.3996 18.903L19.3996 18.9031C19.3997 18.9036 19.3998 18.9042 19.4 18.9048L20.0132 18.7654M19.9675 18.5732L16.8911 13.7319L17.112 13.8056L17.331 13.8786C17.4464 13.9171 17.533 13.9767 17.5751 14.0075C17.6322 14.0494 17.6879 14.0987 17.7414 14.1546C17.8491 14.2669 17.9566 14.4141 18.0576 14.6035L18.0622 14.6123L18.065 14.6178L18.0664 14.6206L18.0666 14.6211L18.3226 15.1334L18.3229 15.1339L18.3256 15.1393L18.3256 15.1394C18.3296 15.1476 18.3339 15.1558 18.3384 15.164C18.4504 15.3684 18.706 15.5658 18.9355 15.6301C18.957 15.6361 18.9783 15.641 18.9992 15.6446L19.0098 15.6462L19.3432 15.6989L19.3511 15.7001M19.9675 18.5732L19.4014 18.911L20.0132 18.7654M19.9675 18.5732L20.0132 18.7654M19.9675 18.5732L19.519 20.7432M19.3531 18.7075C19.2964 18.4465 19.393 18.0864 19.5718 17.8728C19.5825 17.86 19.5935 17.8477 19.6048 17.836M19.3531 18.7075L19.3517 18.7017L19.234 18.7297M19.3531 18.7075C19.3534 18.7088 19.3537 18.7101 19.354 18.7114L19.234 18.7297M19.6048 17.836L19.6097 17.8311L19.9214 17.5193C19.923 17.5176 19.9247 17.5159 19.9264 17.5142M19.6048 17.836C19.6057 17.8351 19.6065 17.8342 19.6074 17.8334L19.516 17.7442L19.5107 17.7495M19.6048 17.836L19.601 17.8398L19.5107 17.7495M19.9264 17.5142L20.3702 17.9505L19.93 17.5106M19.9264 17.5142L19.8354 17.4247C19.8361 17.424 19.8367 17.4233 19.8374 17.4227L19.8397 17.4203L19.93 17.5106M19.9264 17.5142C19.9276 17.513 19.9288 17.5118 19.93 17.5106M19.93 17.5106C20.2168 17.2205 20.3789 16.898 20.3789 16.6045V16.4275L20.3513 16.3724L20.2997 16.2692C20.2473 16.1643 20.1818 16.0956 20.1613 16.0743C20.1284 16.0402 20.0957 16.0119 20.0665 15.9889C20.0074 15.9425 19.9424 15.9022 19.8743 15.8675C19.737 15.7976 19.5684 15.7408 19.3644 15.7026L19.3576 15.7013M19.3576 15.7013L19.455 15.0846L19.3511 15.7001M19.3576 15.7013L19.338 15.8254L19.3338 15.8247C19.3326 15.8245 19.3314 15.8243 19.3302 15.8241L19.3511 15.7001M19.3576 15.7013L19.3538 15.7006L19.3511 15.7001M19.5107 17.7495L19.4954 17.7649L19.4736 17.791C19.348 17.9418 19.2884 18.123 19.264 18.2075C19.2469 18.2666 19.2307 18.3374 19.2215 18.4136C19.2146 18.4718 19.2039 18.5914 19.234 18.7297M19.5107 17.7495L19.0706 17.3096L19.234 18.7297M20.0132 18.7654C20.2878 19.9741 19.8211 20.5235 19.519 20.7432M19.519 20.7432C19.3543 20.8714 19.0889 20.9996 18.7136 20.9996C18.3933 20.9996 17.9815 20.8989 17.4964 20.6059L17.2676 20.4686C17.2035 20.4319 17.0113 20.4319 16.9472 20.4686L16.7184 20.6059C15.6659 21.2377 14.9978 20.9722 14.705 20.7524C14.4029 20.5326 13.9362 19.9833 14.2107 18.7746L19.519 20.7432ZM19.0585 20.1513C19.0155 20.1848 18.9175 20.2436 18.7411 20.2492V19.617V19.0511V19.0502V18.8686C18.7712 18.87 18.7883 18.874 18.7904 18.8745L18.7904 18.8746C18.7904 18.8746 18.7837 18.8728 18.77 18.8676C18.8868 18.8721 19.0025 18.9045 19.1063 18.9633C19.1087 18.9647 19.1111 18.966 19.1134 18.9674C19.1502 18.9888 19.1855 19.0135 19.2187 19.0416C19.2607 19.077 19.295 19.1139 19.323 19.1494C19.3757 19.5072 19.3304 19.7297 19.2813 19.8586C19.2227 20.0128 19.1354 20.0949 19.0778 20.1368L19.068 20.1439L19.0585 20.1513ZM18.799 20.3647C18.7995 20.3647 18.7999 20.3647 18.8003 20.3646L18.799 20.3647Z"
            fill="#5E677C"
            stroke="#5E677C"
            stroke-width="1.5"
          />
        </svg>
      );
    case "CÔNG NỢ":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.5 13.75C9.5 14.72 10.25 15.5 11.17 15.5H13.05C13.85 15.5 14.5 14.82 14.5 13.97C14.5 13.06 14.1 12.73 13.51 12.52L10.5 11.47C9.91 11.26 9.51001 10.94 9.51001 10.02C9.51001 9.17999 10.16 8.48999 10.96 8.48999H12.84C13.76 8.48999 14.51 9.26999 14.51 10.24"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 7.5V16.5"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22 6V2H18"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17 7L22 2"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "BÁO CÁO":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.87988 18.15V16.08"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M12 18.15V14.01"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M17.1201 18.15V11.93"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M17.1199 5.84998L16.6599 6.38998C14.1099 9.36998 10.6899 11.48 6.87988 12.43"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M14.1904 5.84998H17.1204V8.76998"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "LỊCH SỬ THAO TÁC":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.34793 22.325H11.0329C11.1295 22.325 11.2079 22.4034 11.2079 22.5C11.2079 22.5966 11.1295 22.675 11.0329 22.675H5.34793C3.77805 22.675 2.50293 21.4008 2.50293 19.8375V4.16251C2.50293 2.59925 3.77873 1.32501 5.34793 1.32501H16.2912C17.8591 1.32501 19.1354 2.60176 19.1354 4.17001V11.1975C19.1354 11.2941 19.057 11.3725 18.9604 11.3725C18.8638 11.3725 18.7854 11.2941 18.7854 11.1975V4.17001C18.7854 2.7935 17.666 1.67501 16.2904 1.67501H5.34793C3.97325 1.67501 2.85293 2.78891 2.85293 4.16251V19.8375C2.85293 21.2111 3.97325 22.325 5.34793 22.325Z"
            stroke="#5E677C"
          />
          <path
            d="M15.54 7.10602C15.6366 7.10602 15.715 7.18441 15.715 7.28102C15.715 7.37801 15.637 7.45602 15.54 7.45602H6.10273C6.00613 7.45602 5.92773 7.37763 5.92773 7.28102C5.92773 7.18441 6.00613 7.10602 6.10273 7.10602H15.54Z"
            stroke="#5E677C"
          />
          <path
            d="M13.5457 11.825C13.6423 11.825 13.7207 11.9034 13.7207 12C13.7207 12.097 13.6427 12.175 13.5457 12.175H6.10566C6.00906 12.175 5.93066 12.0966 5.93066 12C5.93066 11.9034 6.00906 11.825 6.10566 11.825H13.5457Z"
            stroke="#5E677C"
          />
          <path
            d="M5.93164 16.7175C5.93164 16.6209 6.01003 16.5425 6.10664 16.5425H10.0216C10.1182 16.5425 10.1966 16.6209 10.1966 16.7175C10.1966 16.8141 10.1182 16.8925 10.0216 16.8925H6.10664C6.01003 16.8925 5.93164 16.8141 5.93164 16.7175Z"
            stroke="#5E677C"
          />
          <path
            d="M13.0215 18.438C13.0215 16.1011 14.9224 14.2003 17.2585 14.2003C19.5946 14.2003 21.4962 16.1012 21.4962 18.438C21.4962 20.774 19.5947 22.675 17.2585 22.675C14.9224 22.675 13.0215 20.7741 13.0215 18.438ZM13.3707 18.4373C13.3707 20.5817 15.1149 22.325 17.2585 22.325C19.4021 22.325 21.1462 20.5817 21.1462 18.4373C21.1462 16.2929 19.4029 14.5495 17.2585 14.5495C15.1141 14.5495 13.3707 16.2929 13.3707 18.4373Z"
            stroke="#5E677C"
          />
          <path
            d="M17.434 18.1575V18.3648L17.5806 18.5113L18.2887 19.2186C18.2888 19.2187 18.2888 19.2187 18.2889 19.2188C18.3573 19.2877 18.3573 19.3985 18.2887 19.4672L18.6427 19.8203L18.2892 19.4667C18.2547 19.5012 18.2103 19.5183 18.165 19.5183C18.1202 19.5183 18.076 19.5016 18.0409 19.4668C18.0408 19.4667 18.0406 19.4666 18.0405 19.4665L17.1355 18.5615C17.1024 18.5284 17.084 18.4837 17.084 18.4373V16.5278C17.084 16.4312 17.1624 16.3528 17.259 16.3528C17.3556 16.3528 17.434 16.4312 17.434 16.5278V18.1575Z"
            stroke="#5E677C"
          />
        </svg>
      );

    case "CHI PHÍ NỢ XẤU":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 13V9C2 5.5 4 4 7 4H17C20 4 22 5.5 22 9V15C22 18.5 20 20 17 20H14"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5Z"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.5 9.5V14.5"
            stroke="#5E677C"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.30694 17C5.43439 17 5.53771 17.1033 5.53771 17.2308V18.7692C5.53771 18.8967 5.43439 19 5.30694 19C5.1795 19 5.07617 18.8967 5.07617 18.7692V17.2308C5.07617 17.1033 5.1795 17 5.30694 17Z"
            fill="#5E677C"
          />
          <path
            d="M5.30769 20C5.47763 20 5.61539 19.8622 5.61539 19.6923C5.61539 19.5223 5.47763 19.3846 5.30769 19.3846C5.13775 19.3846 5 19.5223 5 19.6923C5 19.8622 5.13775 20 5.30769 20Z"
            fill="#5E677C"
          />
          <path
            d="M2.9635 18.1046L2.96351 18.1046L3.12513 17.818C3.12513 17.818 3.12513 17.818 3.12514 17.818C3.78657 16.6452 4.24049 15.8448 4.64871 15.3263C5.04787 14.8193 5.27373 14.75 5.44444 14.75C5.61514 14.75 5.841 14.8193 6.24016 15.3263C6.64839 15.8448 7.10232 16.6453 7.76376 17.818L7.92533 18.1045L7.92537 18.1046C8.47796 19.0843 8.84411 19.7383 9.02673 20.2331C9.20365 20.7124 9.12677 20.8241 9.09308 20.8724L9.09306 20.8724C9.03695 20.9529 8.88903 21.089 8.28045 21.1691C7.67773 21.2484 6.83346 21.25 5.60609 21.25H5.2828C4.05542 21.25 3.21115 21.2484 2.60843 21.1691C1.99984 21.089 1.85193 20.9529 1.79581 20.8724L1.18056 21.3013L1.79581 20.8724C1.76212 20.8241 1.68524 20.7124 1.86216 20.2331C2.04478 19.7383 2.41093 19.0843 2.9635 18.1046Z"
            stroke="#5E677C"
            stroke-width="1.5"
          />
        </svg>
      );

    default:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.5 3.75C2.84315 3.75 1.5 5.09315 1.5 6.75V17.25C1.5 18.9069 2.84315 20.25 4.5 20.25H19.5C21.1569 20.25 22.5 18.9069 22.5 17.25V6.75C22.5 5.09315 21.1569 3.75 19.5 3.75H4.5ZM8.625 6.75C7.38236 6.75 6.375 7.75736 6.375 9C6.375 10.2426 7.38236 11.25 8.625 11.25C9.86764 11.25 10.875 10.2426 10.875 9C10.875 7.75736 9.86764 6.75 8.625 6.75ZM4.75191 15.4528C5.3309 13.8765 6.84542 12.75 8.62496 12.75C10.4045 12.75 11.919 13.8765 12.498 15.4528C12.6271 15.8043 12.4771 16.1972 12.1466 16.3733C11.0958 16.9331 9.89627 17.25 8.62496 17.25C7.35364 17.25 6.15413 16.9331 5.10331 16.3733C4.77278 16.1972 4.62279 15.8043 4.75191 15.4528ZM15 8.25C14.5858 8.25 14.25 8.58579 14.25 9C14.25 9.41421 14.5858 9.75 15 9.75H18.75C19.1642 9.75 19.5 9.41421 19.5 9C19.5 8.58579 19.1642 8.25 18.75 8.25H15ZM14.25 12C14.25 11.5858 14.5858 11.25 15 11.25H18.75C19.1642 11.25 19.5 11.5858 19.5 12C19.5 12.4142 19.1642 12.75 18.75 12.75H15C14.5858 12.75 14.25 12.4142 14.25 12ZM15 14.25C14.5858 14.25 14.25 14.5858 14.25 15C14.25 15.4142 14.5858 15.75 15 15.75H18.75C19.1642 15.75 19.5 15.4142 19.5 15C19.5 14.5858 19.1642 14.25 18.75 14.25H15Z"
            fill="#3169F6"
          />
        </svg>
      );
  }
}
